import { render } from "./HomeView.vue?vue&type=template&id=243fca8a&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=243fca8a&scoped=true&lang=css"

import exportComponent from "/home/gremmel/prog/nodejs/bgg-statistic/ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243fca8a"]])

export default __exports__